import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Tab from '@mui/material/Tab';
import MuiDivider from '@mui/material/Divider';
import { Stepper, StepConnector, Step, StepLabel, StepContent, Typography } from '@mui/material';

export const TimelineCnt = styled(Paper)(({ theme }) => ({
  backgroundColor: '#FFF',
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  [theme.breakpoints.down('md')]: {
    height: 'calc(100% - 52px)',
    overflowY: 'auto'
  },
  '& > div': {
    background: 'none'
  }
}));

export const StyledStep = styled(Step)(({ theme }) => ({
  cursor: 'pointer',
  '&:hover .stepContent, &:hover .stepLabelCnt': {
    backgroundColor: theme.palette.grey['200']
  }
}));

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  padding: `${theme.spacing(1, 0)} !important`,
  backgroundColor: 'inherit'
}));

export const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
  position: 'relative',
  marginLeft: 17,
  padding: 0,
  '& .MuiStepLabel-iconContainer': {
    paddingRight: 6,
    marginLeft: theme.spacing(-2)
  }
}));

export const StyledStepContent = styled(StepContent)(({ theme }) => ({
  position: 'relative',
  marginTop: 0,
  padding: theme.spacing(0, 1, 0, 0),
  borderLeft: `3px solid ${theme.palette.grey[600]}`
}));

export const StyledStepConnector = styled(StepConnector)({
  paddingBottom: '0 !important',
  '& .MuiStepConnector-line': {
    minHeight: '0 !important',
    borderLeftWidth: '2px !important'
  }
});

export const Address = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  '&.addressInTooltip': {
    color: theme.palette.common.white
  }
}));

export const ContentWrapper = styled('section')({
  position: 'relative'
});

export const ConnectorVerticalLast = styled('span')({
  position: 'absolute',
  width: 4,
  top: 10,
  bottom: -8,
  left: -3,
  backgroundColor: '#FFF',
  '&.showInTooltip': {
    backdropFilter: 'blur(55px)',
    backgroundColor: '#474848 !important'
  }
});

export const ConnectorHorizontal = styled('span')(({ theme }) => ({
  height: 2,
  width: 10,
  position: 'absolute',
  backgroundColor: theme.palette.grey[600],
  top: 8,
  left: -2,
  borderRadius: 2
}));

export const ConnectorHorizontalOnly = styled('span')(({ theme }) => ({
  height: 2,
  width: 10,
  display: 'block',
  backgroundColor: theme.palette.grey[600]
}));

export const ConnectorSpaceOnly = styled('span')(({ theme }) => ({
  height: 2,
  width: 10,
  display: 'block',
  marginBottom: theme.spacing()
}));

export const ContentCnt = styled('section')(({ theme }) => ({
  margin: theme.spacing(1, 0, 1, 2)
}));

export const TimelineCard = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(),
  paddingLeft: theme.spacing()
}));

export const TimelineCardDesktop = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  overflowY: 'auto',
  '&::-webkit-scrollbar-track': {
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    borderRadius: 10,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar': {
    width: 8,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 10,
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
    backgroundColor: '#a0a0a0'
  }
}));

export const TabCnt = styled('div')({
  position: 'relative'
});

export const TabBar = styled(AppBar)({
  backgroundColor: 'transparent'
});

export const StyledTab = styled(Tab)(({ theme }) => ({
  minWidth: 72,
  display: 'flex',
  flexDirection: 'row',
  '& > span:nth-of-type(2)': {
    marginLeft: theme.spacing(),
    height: 13
  }
}));

export const TabContentCnt = styled('div')(({ theme }) => ({
  height: 'calc(100% - 52px)',
  minHeight: 275,
  overflowY: 'auto',
  [theme.breakpoints.up('md')]: {
    '&::-webkit-scrollbar-track': {
      WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
      borderRadius: 10,
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar': {
      width: 8,
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
      backgroundColor: '#a0a0a0'
    }
  }
}));

export const Divider = styled(MuiDivider)({
  marginTop: '-1px !important'
});
